import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './translations/en.json';
import frTranslation from './translations/fr.json';
import nlTranslation from './translations/nl.json';
import { API_BASE_URL } from './utils/api';

let storedLanguage = 'en';
try {
  storedLanguage = localStorage.getItem('selectedLanguage') || 'en';
} catch {
  // localStorage may throw in private browsing, strict Safari, or when disabled
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      'fr-FR': {
        translation: frTranslation,
      },
      nl: {
        translation: nlTranslation,
      },
    },
    lng: storedLanguage || 'en', 
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, 
    },
  });

// Map i18n language codes to short native codes for the WebView bridge
function toNativeLanguage(lng) {
  if (lng && lng.startsWith('fr')) return 'fr';
  if (lng === 'nl') return 'nl';
  return 'en';
}

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('selectedLanguage', lng);
  } catch {
    // localStorage may be unavailable
  }
  document.title = i18n.t('page_title');
  document.documentElement.lang = lng;
  // Notify native app of language change via WebView bridge
  console.log('language:' + toNativeLanguage(lng));
  // Persist language preference to backend
  if (localStorage.getItem('userId')) {
    fetch(`${API_BASE_URL}/account/update-language`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ language: lng }),
    }).catch(() => {});
  }
});

// Set initial title, lang attribute, and notify native app
document.title = i18n.t('page_title');
document.documentElement.lang = i18n.language || 'en';
console.log('language:' + toNativeLanguage(i18n.language));

export default i18n;
